import { dispatchEvent } from '../src/lib/dom';

/**
 * confirm popup
 *  - triggers custom events on window:
 *      confirmPopupShow
 *      confirmPopupHide
 *  */
export default (props, e) => {
  const {
    espClassName,
    messages,
    appendPU,
  } = props;
  const self = e.target;

  if (!self.getAttribute('data-confirm-popup')) {
    e.preventDefault();

    dispatchEvent(window, 'confirmPopupShow');

    edeeshopPopup.createConfirm({
      confirmClassName: espClassName || '',
      messages: {
        title: messages.title,
        text: messages.text,
        confirmButton: messages.confirmButton,
        declineButton: messages.declineButton
      },
      action: function (response, data, trigger) {

        dispatchEvent(window, 'confirmPopupHide');

        if (response == 'confirm') {
          if (appendPU) {
            self.setAttribute('data-partial-update', 'click');
          }
          self.setAttribute('data-confirm-popup', 'true');
          self.click();
        }
        else {
          self.removeAttribute('data-confirm-popup');
        }
      }
    });
  }
};



// WEBPACK FOOTER //
// ./node_modules/fg-frontend/webActions/confirmPopup.js